import React from 'react';
import $ from 'jquery';
import 'LIBRARY/Components/Reports/StudentWiseLibraryStatistics/StudentWiseLibraryStatistics.css';
import 'LIBRARY/Components/Reports/ResourceListAsPerAccessionNumber/ResourceListAsPerAccessionNumber.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';
import SuccessModal from 'LIBRARY/CommonResources/SuccessModal/SuccessModal';
import Pagination from 'react-js-pagination';
import ReactToPrint from 'react-to-print';
import ReactHtmlParser from 'react-html-parser';
import config from 'config';
import LibraryApiCall from 'LibraryApiCall';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import searchPng from "LIBRARY/CommonResources/images/search-stroke.png";
import advanceFilter from "LIBRARY/CommonResources/images/advanceFilter.svg";
import { toast } from 'react-toastify';
import Select from 'react-select';
import ButtonLoader from 'LIBRARY/CommonResources/ButtonLoader/ButtonLoader';


let resourceTypeData = [
    "Text Book",
    "Reference Book",
    "Atlas",
    "Biography",
    "Book with CD",
    "CD-ROM",
    "Floppy",
    "General",
    "Laboratory Manual",
    "Practical",
    "Practical Manual",
    " Practical Note Book",
    "Text Book(Practical)",
    "Text Book(Theory & Practical)",
    "Question Bank",
    "Project Thesis",
    "Other",
    "Book bank",
    "Bound Volume",
    "Current issue of the journals",
    "Syllabus copy",
    "Previous years question papers copy"
];


class YearlyPurchaseTitleWithCostReport extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            successModal: false,

            // All resource list as per accession series
            resourceListLoading: false,
            totalResourceListItems: 0,
            resourceList: {},
            pageIndex: 1,
            limit: "10",

            // report filter
            // new Date().toISOString().split('T')[0]
            searchByAccessionNumber: '',
            searchByAccessionSeries: [],
            searchByDepartment: [],
            searchByResourceCategory: [],
            searchByResourceType: [],
            billFromDate: "",
            billToDate: "",

            accessionSeriesList: {},
            loadingAccessionSeries: false,
            GetStreamList: {},
            loadingStreamData: false,
            GetResourceCategoryList: {},
            loadingResourceCategoryData: false,

            // custom list column
            selectAll: true,

            //STATE FOR COLUMN VISIBILITY
            exportItemVisibilityForRows: [
                { name: "Date of Purchase", isVisible: true },
                { name: "Invoice/Bill Number", isVisible: true },
                { name: "Title", isVisible: true },
                { name: "Author", isVisible: true },
                { name: "Price Per Copy", isVisible: true },
                { name: "Net Price (in ₹ Per Copy)", isVisible: true },
                { name: "Discount (in %)", isVisible: true },
                { name: "Accession Series", isVisible: true },
                { name: "Accession Number", isVisible: true },
                { name: "Number Of Copies", isVisible: true },
                { name: "Call Number", isVisible: true },
                { name: "Resource Category", isVisible: true },
                { name: "Department", isVisible: true },
                { name: "Resource Type", isVisible: true }
            ],

            //STATE FOR header
            exportCSVHeaders: [
                { name: "Date of Purchase", key: 'dateOfPurchase' },
                { name: "Invoice/Bill Number", key: 'invoiceNumber' },
                { name: "Title", key: 'title' },
                { name: "Author", key: 'author' },
                { name: "Price Per Copy", key: 'price' },
                { name: "Net Price (in ₹ Per Copy)", key: 'netPrice' },
                { name: "Discount (in %)", key: 'discount' },
                { name: "Accession Series", key: 'accessionSeries' },
                { name: "Accession Number", key: 'accessionNumber' },
                { name: "Number Of Copies", key: 'numberOfCopies' },
                { name: "Call Number", key: 'callNumber' },
                { name: "Resource Category", key: 'resourceCategory' },
                { name: "Department", key: 'department' },
                { name: "Resource Type", key: 'resourceType' }
            ],

            exportItemVisibility: [
                { name: "Date of Purchase", isVisible: true },
                { name: "Invoice/Bill Number", isVisible: true },
                { name: "Title", isVisible: true },
                { name: "Author", isVisible: true },
                { name: "Price Per Copy", isVisible: true },
                { name: "Net Price (in ₹ Per Copy)", isVisible: true },
                { name: "Discount (in %)", isVisible: true },
                { name: "Accession Series", isVisible: true },
                { name: "Accession Number", isVisible: true },
                { name: "Number Of Copies", isVisible: true },
                { name: "Call Number", isVisible: true },
                { name: "Resource Category", isVisible: true },
                { name: "Department", isVisible: true },
                { name: "Resource Type", isVisible: true }
            ],

            // export all
            isExportAllReportDataFetching: false,
            allReportData: {},
            allSortedIdArray: [],
            sortedIdArray: [],

            // total count
            priceTotalCount: 0,

            // grand total count
            priceTotal: 0,

            //advance filter modal
            advanceFilterModal: false,
        };
    }

    componentDidMount() {
        this.GetLibraryYearlyPerchaceResourceListForReport();  // report list
        this.apiCallToGetAccessionSeries(); // accession series
        this.apiCallToGetInstituteStreamList();  // department
        this.GetLibraryResourceCategoryListWithBasicDetails();  // resource category
        this.formatCSVExportData('onLoad'); // export data
    }

    //API CALL METHOD TO LIST OF REPORT
    GetLibraryYearlyPerchaceResourceListForReport = async () => {
        this.setState({
            resourceListLoading: true
        });

        let accessionSeriesIdArray = [];
        let departmentIdArray = [];
        let categoryIdArray = [];
        let typeNameArray = [];

        this.state.searchByAccessionSeries?.map((item) => {
            accessionSeriesIdArray.push(item.value)
        })

        this.state.searchByDepartment?.map((item) => {
            departmentIdArray.push(item.value)
        })

        this.state.searchByResourceCategory?.map((item) => {
            categoryIdArray.push(item.value)
        })

        this.state.searchByResourceType?.map((item) => {
            typeNameArray.push(item.value)
        })

        let searchAccessionNumberValue = this.state.searchByAccessionNumber || "";
        let searchBillStartDate = this.state.billFromDate;
        let searchBillEndDate = this.state.billToDate;
        let searchAccessionSeriesValue = accessionSeriesIdArray;
        let searchDepartmentValue = departmentIdArray;
        let searchCategoryValue = categoryIdArray;
        let searchTypeValue = typeNameArray;

        let filterParameter = {

            "searchAccessionNumber": searchAccessionNumberValue,
            "startDate": searchBillStartDate,
            "endDate": searchBillEndDate,
            "searchseries": searchAccessionSeriesValue,
            "streams": searchDepartmentValue,
            "searchresourcecategory": searchCategoryValue,
            "searchType": searchTypeValue,
        };

        let requestData = {
            'iid': config.institute_id,
            'pageIndex': this.state.pageIndex,
            'limitPerPage': this.state.limit,
            'filterParameter': filterParameter
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryYearlyPerchaceResourceListForReport',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryYearlyPerchaceResourceListForReport()
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                if (apiResult?.data) {
                    if (apiResult.success == 'true') {
                        // Use reduce to accumulate totals
                        const totals = Object.values(apiResult.data).reduce((accumulator, resource) => {
                            const keyPrice = resource.price || 0;

                            // Accumulate totals
                            accumulator.totalPrice += parseInt(keyPrice);
                            return accumulator;
                        }, {
                            totalPrice: 0,
                        });

                        this.setState({
                            resourceList: apiResult.data,
                            totalResourceListItems: apiResult?.totalRecords,
                            priceTotal: apiResult?.grandTotal,
                            priceTotalCount: totals.totalPrice,
                            resourceListLoading: false
                        });
                    } else {
                        this.setState({
                            resourceList: {},
                            totalResourceListItems: 0,
                            priceTotalCount: 0,
                            priceTotal: 0,
                            resourceListLoading: false
                        });
                    }
                } else {
                    this.setState({
                        successModal: true,
                        successModalType: 'warning',
                        successMessage: apiResult.message,
                    });

                    this.setState({
                        resourceList: {},
                        totalResourceListItems: 0,
                        resourceListLoading: false
                    });
                }
            }
        }
    }

    //API CALL METHOD TO GET ACCESSION SERIES
    apiCallToGetAccessionSeries = async () => {
        this.setState({ loadingAccessionSeries: true });

        let requestData = {
            "iid": config.institute_id,
        };

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryAccessionSeries',
            requestData,
            '/api/library/instructor.php'
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetAccessionSeries();
            }, 1000);
        } else {
            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult.data;

                if (Object.keys(apiResult).length > 0) {
                    Object.keys(apiResult).map(seriesId => {
                        apiResult[seriesId]['seriesId'] = seriesId;
                    });
                }

                const formattedMembers = Object.entries(jsonResponse.APIResult.data).map(([seriesId, seriesData]) => ({
                    value: seriesData.seriesId, // Use `faculty_id` as the value
                    label: seriesData?.seriestext, // Display name
                }));

                this.setState({
                    accessionSeriesList: formattedMembers,
                    loadingAccessionSeries: false
                });
            } else {
                this.setState({
                    successModal: true,
                    successModalType: 'error',
                    successMessage: 'Something went wrong while getting accession series list. Please try again later.',
                    loadingAccessionSeries: false
                });
            }
        }
    }

    // API CALL TO GET get Institute Stream List 
    apiCallToGetInstituteStreamList = async () => {
        this.setState({
            loadingStreamData: true,
        })
        let requestData = {
            "iid": config.institute_id,
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'getInstituteStreamList',
            requestData,
            "/api/instructor/facultyRegistration.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.apiCallToGetInstituteStreamList();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                this.setState({
                    GetStreamList: apiResult.streamData,
                    loadingStreamData: false,
                })
            } else {
                this.setState({
                    loadingStreamData: false,
                })
            }
        }
    }

    // API CALL TO GET get resource category List 
    GetLibraryResourceCategoryListWithBasicDetails = async () => {
        this.setState({
            loadingResourceCategoryData: true,
        })
        let requestData = {
            iid: config.institute_id,
            isSortByAscendingCategoryName: "true"
        }

        let jsonResponse = await LibraryApiCall.makeApiCall(
            'GetLibraryResourceCategoryListWithBasicDetails',
            requestData,
            "/api/library/instructor.php"
        );

        if (jsonResponse.expired) {
            setTimeout(() => {
                this.GetLibraryResourceCategoryListWithBasicDetails();
            }, 1000);
        } else {

            if (jsonResponse.success) {
                let apiResult = jsonResponse.APIResult;

                const formattedData = Object.entries(apiResult.data).map(([seriesId, seriesData]) => {
                    // Initialize an empty array to hold sublocations
                    const subCategories = [];

                    // If there are subCategories, iterate through them
                    if (Object.values(seriesData.subresource).length > 0) {
                        Object.entries(seriesData.subresource).forEach(([subCategoryId, subCategoryData]) => {
                            subCategories.push({
                                subCategoryId: subCategoryId,
                                subCategoryName: subCategoryData.name,
                                parentId: subCategoryData.parentCategoryId
                            });
                        });
                    }

                    // Return the formatted data
                    return {
                        value: seriesId,
                        name: seriesData?.name, // Display name
                        uniqueId: seriesId,
                        subCategories: subCategories // Add subresource data (if any)
                    };
                });


                this.setState({
                    GetResourceCategoryList: formattedData,
                    loadingResourceCategoryData: false,
                })
            } else {
                this.setState({
                    loadingResourceCategoryData: false,
                })
            }
        }
    }

    // filter Accession Number on change
    handleFilterAccessionNoChange = (event) => {
        this.setState({ pageIndex: 1, limit: "10", searchByAccessionNumber: event.target.value });
    };
    handleResourceAccessionNoKeyPress = (event) => {
        if (event.key === 'Enter') {
            this.GetLibraryYearlyPerchaceResourceListForReport();
        }
    };

    // on change for show entries per page
    changeShowEntriesControl = (event) => {
        this.setState({
            pageIndex: 1, limit: event.target.value, searchByAccessionNumber: this.state.searchByAccessionNumber, searchByAccessionSeries: this.state.searchByAccessionSeries, searchByDepartment: this.state.searchByDepartment, searchByResourceCategory: this.state.searchByResourceCategory, searchByResourceType: this.state.searchByResourceType, billFromDate: this.state.billFromDate, billToDate: this.state.billToDate
        }, () => {
            this.GetLibraryYearlyPerchaceResourceListForReport();
        });

    }

    // on change for per page change
    updatePaginationCount = (pageNumber) => {
        this.setState({ pageIndex: pageNumber, searchByAccessionNumber: this.state.searchByAccessionNumber, searchByAccessionSeries: this.state.searchByAccessionSeries, searchByDepartment: this.state.searchByDepartment, searchByResourceCategory: this.state.searchByResourceCategory, searchByResourceType: this.state.searchByResourceType, billFromDate: this.state.billFromDate, billToDate: this.state.billToDate }, () => {
            this.GetLibraryYearlyPerchaceResourceListForReport();
        });
    };

    // CLEAR ALL FILTER
    handleClearAllReportFilter = () => {
        this.setState({
            searchByAccessionNumber: '', searchByAccessionSeries: [], searchByDepartment: [], searchByResourceCategory: [], searchByResourceType: [], billFromDate: "", billToDate: "",
            limit: "10", pageIndex: 1
        }, () => {
            this.GetLibraryYearlyPerchaceResourceListForReport();
        }
        )
    };

    // column visibility on change
    updateColumnDisplay = (columnIndex) => {
        let exportItemVisibilityForRows = this.state.exportItemVisibilityForRows;

        exportItemVisibilityForRows[columnIndex].isVisible = !exportItemVisibilityForRows[columnIndex].isVisible;

        this.setState({
            exportItemVisibilityForRows
        });
    }

    //FUNCTION DEFINED TO INITIATE THE EXPORT DOWNLOAD PROCESS FOR DEPARTMENT LIST
    exportCSVData = () => {
        document.getElementById('export').click();
    }

    exportAllReportCSV = () => {
        document.getElementById('exportAll').click();
    }

    // FUNCTION TO FORMAT DATA BEFORE EXPORTING
    formatCSVExportData = (action) => {
        let exportSelectedCSVHeaders = this.state.exportSelectedCSVHeaders;

        exportSelectedCSVHeaders = [{ label: "Sr.No.", key: "srNo" },];

        this.state.exportCSVHeaders.map(csvInfo => {
            this.state.exportItemVisibility.map(columnInfo => {
                if (csvInfo.label == columnInfo.name) {
                    if (columnInfo.isVisible) {
                        exportSelectedCSVHeaders.push(csvInfo);
                    }
                }
            });
        });

        this.setState({
            exportSelectedCSVHeaders
        }, () => {
            if (action != 'onLoad') {
                this.exportCSVData();
            }
        });
    }

    // export all functionality
    returnExportAllData = () => {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterAccessionSeries = this.state.searchByAccessionSeries
        let filterAccessionNumber = this.state.searchByAccessionNumber
        let filterBillFromDate = this.state.billFromDate
        let filterBillToDate = this.state.billToDate
        let filterDepartment = this.state.searchByDepartment
        let filterResourceCategory = this.state.searchByResourceCategory
        let filterResourceType = this.state.searchByResourceType

        if (this.state.searchByAccessionSeries && filterAccessionSeries.length > 0) {
            FilterArray.push(`Accession Series - ${filterAccessionSeries?.map(item => item.label).join(", ")}`)
        }
        if (filterAccessionNumber) {
            FilterArray.push(`Accession Number - ${filterAccessionNumber}`)
        }

        if (filterBillFromDate) {
            FilterArray.push(`Bill From Date - ${filterBillFromDate}`)
        }
        if (filterBillToDate) {
            FilterArray.push(`Bill To Date - ${filterBillToDate}`)
        }
        if (this.state.searchByDepartment && filterDepartment.length > 0) {
            FilterArray.push(`Department - ${filterDepartment?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceCategory && filterResourceCategory.length > 0) {
            FilterArray.push(`Resource Category - ${filterResourceCategory?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceType && filterResourceType.length > 0) {
            FilterArray.push(`Resource Type - ${filterResourceType?.map(item => item.label).join(", ")}`)
        }

        return (
            <table className="table table-bordered" id="ExportAllYearlyPurchaseTitlesWithCostReport" style={{ marginTop: '15px', display: 'none' }}>
                <thead>
                    <tr>
                        <tr className='d-none'>
                            <th colSpan="30" style={{ textAlign: 'center' }}>
                                {config.institute_name}
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="30" style={{ textAlign: 'center' }}>
                                Yearly Purchase Titles With Cost
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="30" ></th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="30" style={{ textAlign: 'center' }}>
                                {
                                    FilterArray.join(" | ")
                                }
                            </th>
                        </tr>
                        <tr className='d-none'>
                            <th colSpan="30" ></th>
                        </tr>
                        <th>Sr.No</th>
                        {this.state.exportItemVisibilityForRows[0].isVisible && <th>Date of Purchase</th>}
                        {this.state.exportItemVisibilityForRows[1].isVisible && <th>Invoice/Bill Number</th>}
                        {this.state.exportItemVisibilityForRows[2].isVisible && <th>Title</th>}
                        {this.state.exportItemVisibilityForRows[3].isVisible && <th>Author</th>}
                        {this.state.exportItemVisibilityForRows[4].isVisible && <th>Price Per Copy</th>}
                        {this.state.exportItemVisibilityForRows[5].isVisible && <th>Net Price (in ₹ Per Copy)</th>}
                        {this.state.exportItemVisibilityForRows[6].isVisible && <th>Discount (in %)</th>}
                        {this.state.exportItemVisibilityForRows[7].isVisible && <th>Accession Series</th>}
                        {this.state.exportItemVisibilityForRows[8].isVisible && <th>Accession Number</th>}
                        {this.state.exportItemVisibilityForRows[9].isVisible && <th>Number Of Copies</th>}
                        {this.state.exportItemVisibilityForRows[10].isVisible && <th>Call Number</th>}
                        {this.state.exportItemVisibilityForRows[11].isVisible && <th>Resource Category</th>}
                        {this.state.exportItemVisibilityForRows[12].isVisible && <th>Department</th>}
                        {this.state.exportItemVisibilityForRows[13].isVisible && <th>Resource Type</th>}
                    </tr>
                </thead>

                <tbody>
                    {
                        this.state.isExportAllReportDataFetching ?
                            <tr>
                                <td colSpan="11">
                                    <ButtonLoader />
                                </td>
                            </tr>
                            :
                            Object.keys(this.state.allReportData).length > 0 ?
                                (Object.values(this.state.allReportData).map((resource, index) => {
                                    return (

                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {this.state.exportItemVisibilityForRows[0].isVisible && <td>{resource?.dateOfPurchace || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[1].isVisible && <td>{resource?.billno || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[2].isVisible && <td>{resource?.title || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[3].isVisible && <td>{resource?.author || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[4].isVisible && <td>{resource?.price || "-"}</td>}
                                            {this.state.exportItemVisibilityForRows[5].isVisible && <td>{resource?.netprice || "-"}</td>}
                                            {this.state.exportItemVisibilityForRows[6].isVisible && <td>{resource?.discount || "-"}</td>}
                                            {this.state.exportItemVisibilityForRows[7].isVisible && <td>{resource?.AccessionText || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[8].isVisible && <td>{resource?.accessionnumber || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[9].isVisible && <td>{resource?.noOfCopies || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[10].isVisible && <td>{resource?.callNumber || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[11].isVisible && <td>{resource?.resourceCategoryName || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[12].isVisible && <td>{resource?.stream_name || ""}</td>}
                                            {this.state.exportItemVisibilityForRows[13].isVisible && <td>{resource?.resource_type || ""}</td>}
                                        </tr>
                                    )
                                })) :
                                <tr>
                                    <td colSpan="11">
                                        No data found.
                                    </td>
                                </tr>
                    }
                </tbody>
            </table>
        );
    };

    // METHOD TO GET EXPORT REPORT DATA RECURSIVELY
    methodToExportReportData = async (pageIndex) => {
        const { totalResourceListItems } = this.state;
        const totalPages = Math.ceil(totalResourceListItems / 50);
        let allReportData = { ...this.state.allReportData };
        let allSortedIdArray = [...this.state.allSortedIdArray];

        pageIndex++; // Increment page index to fetch the next set of data

        if (pageIndex <= totalPages) {
            this.setState({
                isExportAllReportDataFetching: true
            });

            let accessionSeriesIdArray = [];
            let departmentIdArray = [];
            let categoryIdArray = [];
            let typeNameArray = [];

            this.state.searchByAccessionSeries?.map((item) => {
                accessionSeriesIdArray.push(item.value)
            })

            this.state.searchByDepartment?.map((item) => {
                departmentIdArray.push(item.value)
            })

            this.state.searchByResourceCategory?.map((item) => {
                categoryIdArray.push(item.value)
            })

            this.state.searchByResourceType?.map((item) => {
                typeNameArray.push(item.value)
            })

            let searchAccessionNumberValue = this.state.searchByAccessionNumber || "";
            let searchBillStartDate = this.state.billFromDate;
            let searchBillEndDate = this.state.billToDate;
            let searchAccessionSeriesValue = accessionSeriesIdArray;
            let searchDepartmentValue = departmentIdArray;
            let searchCategoryValue = categoryIdArray;
            let searchTypeValue = typeNameArray;

            let filterParameter = {
                "searchAccessionNumber": searchAccessionNumberValue,
                "startDate": searchBillStartDate,
                "endDate": searchBillEndDate,
                "searchseries": searchAccessionSeriesValue,
                "streams": searchDepartmentValue,
                "searchresourcecategory": searchCategoryValue,
                "searchType": searchTypeValue,
            };

            let requestData = {
                'iid': config.institute_id,
                'pageIndex': pageIndex,
                'limitPerPage': 50,
                'filterParameter': filterParameter
            };

            let jsonResponse = await LibraryApiCall.makeApiCall(
                'GetLibraryYearlyPerchaceResourceListForReport',
                requestData,
                '/api/library/instructor.php'
            );

            if (jsonResponse.expired) {
                setTimeout(() => {
                    this.methodToExportReportData(pageIndex);
                }, 1000);
            } else {
                if (jsonResponse.success) {
                    let apiResult = jsonResponse.APIResult.data;
                    let sortedResponseArrayFromApi = jsonResponse.APIResult.sortedIdArray || [];

                    // Concatenate new data and update state
                    this.setState({
                        allReportData: { ...allReportData, ...apiResult },
                        allSortedIdArray: [...allSortedIdArray, ...sortedResponseArrayFromApi],
                        totalRecords: jsonResponse.APIResult.totalRecords,
                    }, () => {
                        // Fetch the next page recursively
                        this.methodToExportReportData(pageIndex);
                    });
                } else {
                    this.setState({
                        isExportAllReportDataFetching: false,
                        successModal: true,
                        successModalType: 'error',
                        successMessage: 'Something went wrong while getting assessment data. Please try again later.'
                    });
                }
            }
        } else {
            // Final step when all pages are fetched
            this.setState({
                isExportAllReportDataFetching: false,
            }, () => {
                // Trigger any further actions after fetching all data
                setTimeout(() => {
                    this.exportAllReportCSV();
                }, 500);
            });
        }
    };

    // METHOD TO ADVANCE FILTER
    returnAdvanceFilterModelData = () => {
        return (
            <div style={{ display: this.state.advanceFilterModal ? 'flex' : 'none' }} id="reportsSideMenu">
                <div id="reportDataContainer">
                    {/* Modal Header */}
                    <div className="modal-header" style={{ padding: '20px 25px', borderBottom: '2px solid #e0e0e0' }}>
                        <h6 className="modal-title">
                            {/* <img src={advanceFilter} alt="Advanced Filter" style={{ marginRight: '10px', color: '#fff' }} /> */}
                            <FontAwesomeIcon size='sm' icon={["fa", "filter"]} style={{ marginRight: '10px' }} />
                            Advanced Filter
                        </h6>
                        <FontAwesomeIcon icon={['fas', 'times']} className="text-white" size="sm" onClick={() => { this.setState({ advanceFilterModal: false }) }} style={{ cursor: "pointer" }} />
                    </div>

                    {/* Modal Content */}
                    <div className='col-md-12 pt-2 pb-3'>
                        {/* Form Group: department and resource category*/}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Department</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={Object.values(this.state.GetStreamList).map(item => ({
                                            value: item.sid,
                                            label: item.name,
                                        }))}
                                        value={this.state.searchByDepartment}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                searchByDepartment: event || [], // Handle empty selection
                                            });
                                        }}
                                        placeholder="Select Department"
                                        isLoading={this.state.loadingStreamData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingStreamData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Resource Category</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={Object.values(this.state.GetResourceCategoryList).flatMap(item => {
                                            // Start with the category itself
                                            const categoryOption = {
                                                value: item.value,
                                                label: item.name,
                                                isDisabled: item.subCategories.length > 0, // Disable the category if it has subcategories
                                            };

                                            // If the category has subcategories, add those as well
                                            const subCategoryOptions = item.subCategories.map(subCategory => ({
                                                value: subCategory.subCategoryId,
                                                label: `${item.name} => ${subCategory.subCategoryName}`, // Parent category name followed by subcategory name
                                                isDisabled: false, // Subcategory is always enabled
                                            }));

                                            // Return the category option followed by the subcategory options
                                            return [categoryOption, ...subCategoryOptions];
                                        })}
                                        value={this.state.searchByResourceCategory}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                searchByResourceCategory: event || [], // Handle empty selection
                                            });
                                        }}
                                        placeholder="Select Resource Category"
                                        isLoading={this.state.loadingResourceCategoryData} // Show loading spinner while fetching
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                        noOptionsMessage={() => (this.state.loadingResourceCategoryData ? "Loading..." : "No options found")}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Form Group: Resource Type and  Resource Status*/}
                        <div className="form-group row" style={{ marginBottom: '15px' }}>
                            <div className="col-md-6">
                                <label className="vm_custom_body3" color='#454E52'>Resource Type</label>
                                <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                    <Select
                                        isMulti
                                        options={resourceTypeData.map((item) => ({
                                            label: item,
                                            value: item
                                        }))}
                                        value={this.state.searchByResourceType}
                                        className="basic-multi-select-filter"
                                        onChange={(event) => {
                                            this.setState({
                                                searchByResourceType: event || [], // Handle empty selection
                                            });
                                        }}
                                        placeholder="Select Resource Type"
                                        styles={{
                                            control: (base) => ({
                                                ...base,
                                                width: '100%',
                                                minHeight: 42, // Minimum height for the control area
                                                height: 'auto', // Allow control to grow dynamically
                                            }),
                                            multiValue: (base) => ({
                                                ...base,
                                                backgroundColor: 'none',
                                                borderRadius: '5px',
                                                border: '1px solid #c4c5c5',
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                color: '#808080',
                                                display: 'inline-flex',
                                                margin: '2px',
                                                whiteSpace: 'nowrap',
                                            }),
                                            multiValueContainer: (base) => ({
                                                ...base,
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                overflowX: 'auto', // Horizontal scroll when values overflow
                                                minHeight: 42, // Ensure consistent height when values are selected
                                            }),
                                            menu: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Ensure the dropdown appears above other elements
                                            }),
                                            menuPortal: (base) => ({
                                                ...base,
                                                zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                            }),
                                            placeholder: (base) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                            }),
                                            option: (base, state) => ({
                                                ...base,
                                                fontSize: '12px',
                                                fontWeight: '400',
                                                backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                color: state.isSelected ? '#333' : '#555',
                                            }),
                                        }}
                                        menuPortalTarget={document.body}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Modal Footer */}
                    <div className="modal-footer" style={{ padding: '20px 25px' }}>
                        <button
                            className="btn custom-btn"
                            style={{ fontSize: '14px', borderRadius: '7px' }}
                            // borderColor: '#0465AC !important'
                            onClick={() => {

                                this.setState({
                                    advanceFilterModal: false, searchByAccessionNumber: '', searchByAccessionSeries: [], searchByDepartment: [], searchByResourceCategory: [], searchByResourceType: [], billFromDate: "", billToDate: "",
                                    limit: "10", pageIndex: 1
                                }, () => {
                                    this.apiCallToGetAccessionSeries(); // accession series
                                    this.GetLibraryResourceCategoryListWithBasicDetails();  // resource category
                                    this.apiCallToGetInstituteStreamList(); // stream (department)
                                })
                            }}
                        >
                            Clear
                        </button>
                        <button className="btn btn-primary" style={{ fontSize: '14px', borderRadius: '7px' }} onClick={() => {
                            this.setState({ advanceFilterModal: false }, () => {
                                this.GetLibraryYearlyPerchaceResourceListForReport();
                            })
                        }}>
                            Apply
                        </button>
                    </div>
                </div>
            </div >
        );
    }

    render() {
        // display applied filters while exporting data
        let FilterArray = [];

        let filterAccessionSeries = this.state.searchByAccessionSeries
        let filterAccessionNumber = this.state.searchByAccessionNumber
        let filterBillFromDate = this.state.billFromDate
        let filterBillToDate = this.state.billToDate
        let filterDepartment = this.state.searchByDepartment
        let filterResourceCategory = this.state.searchByResourceCategory
        let filterResourceType = this.state.searchByResourceType

        if (this.state.searchByAccessionSeries && filterAccessionSeries.length > 0) {
            FilterArray.push(`Accession Series - ${filterAccessionSeries?.map(item => item.label).join(", ")}`)
        }
        if (filterAccessionNumber) {
            FilterArray.push(`Accession Number - ${filterAccessionNumber}`)
        }

        if (filterBillFromDate) {
            FilterArray.push(`Bill From Date - ${filterBillFromDate}`)
        }
        if (filterBillToDate) {
            FilterArray.push(`Bill To Date - ${filterBillToDate}`)
        }
        if (this.state.searchByDepartment && filterDepartment.length > 0) {
            FilterArray.push(`Department - ${filterDepartment?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceCategory && filterResourceCategory.length > 0) {
            FilterArray.push(`Resource Category - ${filterResourceCategory?.map(item => item.label).join(", ")}`)
        }
        if (this.state.searchByResourceType && filterResourceType.length > 0) {
            FilterArray.push(`Resource Type - ${filterResourceType?.map(item => item.label).join(", ")}`)
        }

        return (
            <div>
                <div className="pl-3 pr-3" style={{ height: '100%' }}>
                    <div style={{ height: '100%' }}></div>
                    <div className="studentStatisticalReport">
                        <div>
                            {/* header */}
                            <div className="card" style={{ marginTop: '20px', boxShadow: 'none', borderRadius: '7px 7px 0px 0px', border: '1px solid #E0E8EF', padding: '8px' }}>
                                <div className="d-flex col-md-12 px-0">
                                    <div className="col-md-10 d-flex justify-content-start align-items-center p-0">
                                        {/* action button - filter */}
                                        <div className="d-flex">
                                            <div>
                                                {/* filter data form*/}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap', paddingLeft: '14px', justifyContent: 'space-between', paddingRight: '14px' }}>
                                                    <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '10px' }}>
                                                        {/* Based On Search by accession series */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Accession Series</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <Select
                                                                    isMulti
                                                                    options={this.state.accessionSeriesList}
                                                                    value={this.state.searchByAccessionSeries}
                                                                    className="basic-multi-select-filter"
                                                                    onChange={(event) => {
                                                                        this.setState({
                                                                            searchByAccessionSeries: event || [], // Handle empty selection
                                                                        }, () => {
                                                                            this.GetLibraryYearlyPerchaceResourceListForReport()
                                                                        });
                                                                    }}
                                                                    placeholder="Select Accession Series"
                                                                    isLoading={this.state.loadingAccessionSeries} // Show loading spinner while fetching
                                                                    styles={{
                                                                        control: (base) => ({
                                                                            ...base,
                                                                            width: '100%',
                                                                            minHeight: 42, // Minimum height for the control area
                                                                            height: 'auto', // Allow control to grow dynamically
                                                                        }),
                                                                        multiValue: (base) => ({
                                                                            ...base,
                                                                            backgroundColor: 'none',
                                                                            borderRadius: '5px',
                                                                            border: '1px solid #c4c5c5',
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                            color: '#808080',
                                                                            display: 'inline-flex',
                                                                            margin: '2px',
                                                                            whiteSpace: 'nowrap',
                                                                        }),
                                                                        multiValueContainer: (base) => ({
                                                                            ...base,
                                                                            display: 'flex',
                                                                            flexWrap: 'wrap',
                                                                            overflowX: 'auto', // Horizontal scroll when values overflow
                                                                            minHeight: 42, // Ensure consistent height when values are selected
                                                                        }),
                                                                        menu: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Ensure the dropdown appears above other elements
                                                                        }),
                                                                        menuPortal: (base) => ({
                                                                            ...base,
                                                                            zIndex: 9999, // Make sure the dropdown portal also respects the z-index
                                                                        }),
                                                                        placeholder: (base) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                        }),
                                                                        option: (base, state) => ({
                                                                            ...base,
                                                                            fontSize: '12px',
                                                                            fontWeight: '400',
                                                                            backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
                                                                            color: state.isSelected ? '#333' : '#555',
                                                                        }),
                                                                    }}
                                                                    menuPortalTarget={document.body}
                                                                    noOptionsMessage={() => (this.state.loadingAccessionSeries ? "Loading..." : "No options found")}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On Search by accession number */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Accession Number</label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <img
                                                                    src={searchPng}
                                                                    style={{
                                                                        position: 'absolute',
                                                                        left: '10px',
                                                                        top: '50%',
                                                                        transform: 'translateY(-50%)',
                                                                        color: '#ccc',
                                                                        backgroundColor: 'white',
                                                                        width: '15px',
                                                                        height: '15px',
                                                                        zIndex: 1,
                                                                    }}
                                                                />
                                                                <input
                                                                    type="text"
                                                                    className="form-control formControlAutoTask"
                                                                    id="searchByAccessionNoFilter"
                                                                    placeholder="Accession Number"
                                                                    style={{ height: '42px', color: '#808080', paddingLeft: '34px', zIndex: 0, borderRadius: '7px', width: '200px', fontSize: "13px" }}
                                                                    value={this.state.searchByAccessionNumber}
                                                                    onChange={this.handleFilterAccessionNoChange} // Handle input changes
                                                                    onKeyPress={this.handleResourceAccessionNoKeyPress} // Trigger API call on Enter
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On Search by bill from date */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Bill From Date<span className="mx-2 text-danger">*</span></label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', height: '41px' }}
                                                                    placeholder="Select Bill From Date"
                                                                    value={this.state.billFromDate}
                                                                    // onChange={(event) => {
                                                                    //     this.setState({
                                                                    //         billFromDate: event.target.value || '', // Handle empty selection
                                                                    //     }, () => {
                                                                    //         this.GetLibraryYearlyPerchaceResourceListForReport()
                                                                    //     });
                                                                    // }}
                                                                    onChange={(event) => {
                                                                        const newFromDate = event.target.value || "";
                                                                        this.setState(
                                                                            {
                                                                                billFromDate: newFromDate,
                                                                                // Reset billToDate if it's before the new from date
                                                                                billToDate:
                                                                                    this.state.billToDate && newFromDate && this.state.billToDate < newFromDate
                                                                                        ? ""
                                                                                        : this.state.billToDate,
                                                                            },
                                                                            () => {
                                                                                this.GetLibraryYearlyPerchaceResourceListForReport();
                                                                            }
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>

                                                        {/* Based On Search by bill to date */}
                                                        <div className="mb-2  p-1">
                                                            <label className="vm_custom_body3" color='#454E52'>Bill To Date<span className="mx-2 text-danger">*</span></label>
                                                            <div className="input-group input-group-field" style={{ position: 'relative' }}>
                                                                <input
                                                                    type="date"
                                                                    className="form-control"
                                                                    style={{ fontSize: '14px', paddingLeft: '10px', paddingTop: '5px', paddingBottom: '6px', height: '41px' }}
                                                                    placeholder="Select Bill To Date"
                                                                    value={this.state.billToDate}
                                                                    // onChange={(event) => {
                                                                    //     this.setState({
                                                                    //         billToDate: event.target.value || '', // Handle empty selection
                                                                    //     }, () => {
                                                                    //         this.GetLibraryYearlyPerchaceResourceListForReport()
                                                                    //     });
                                                                    // }}
                                                                    onChange={(event) => {
                                                                        const newToDate = event.target.value || "";
                                                                        if (newToDate && this.state.billFromDate && newToDate < this.state.billFromDate) {
                                                                            toast.error('Bill To Date cannot be earlier than Bill From Date.', {
                                                                                position: "top-right",
                                                                                autoClose: 2000,
                                                                                hideProgressBar: false,
                                                                                closeOnClick: true,
                                                                                pauseOnHover: true,
                                                                                draggable: true,
                                                                                progress: undefined,
                                                                            });
                                                                            return;
                                                                        }
                                                                        this.setState(
                                                                            { billToDate: newToDate },
                                                                            () => {
                                                                                this.GetLibraryYearlyPerchaceResourceListForReport();
                                                                            }
                                                                        );
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <p style={{ marginLeft: "20px", color: '#7A7A7A', fontSize: '12px' }}>Select "Bill From Date & Bill To Date" to get Yearly Purchase Titles With Cost filter result.</p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="col-md-2 d-flex justify-content-end align-items-center p-0">
                                        <div className="d-flex ml-2" title="Advance Filter">
                                            <button className="btn outline-button" style={{ borderRadius: '5px', boxShadow: 'none' }} onClick={() => {
                                                this.setState({
                                                    advanceFilterModal: true,
                                                })
                                            }}> <style type="text/css" media="print">
                                                    {"@page { size: auto; }"}
                                                </style>
                                                <FontAwesomeIcon size='lg' icon={faSlidersH} style={{ cursor: "pointer", color: '#0465AC' }} />
                                            </button>
                                        </div>

                                        {Object.keys(this.state.resourceList).length == 0 ? null :
                                            <>
                                                <div className="d-flex">
                                                    {this.state.isExportAllReportDataFetching && <div><ButtonLoader /></div>}
                                                </div>

                                                {/* 1 action button - export data */}
                                                <div className="d-flex ml-2" title="Click to Export" >
                                                    <button className="btn outline-button" id='exportDropdownMenu' data-toggle="dropdown" aria-expanded="false" data-bs-toggle="dropdown" aria-haspopup="true" style={{ borderRadius: '5px', boxShadow: 'none' }}> <style type="text/css" media="print">
                                                        {"@page { size: auto; }"}
                                                    </style><FontAwesomeIcon size='lg' icon={["fa", "file-export"]} style={{ cursor: "pointer", color: '#0465AC' }} /></button>

                                                    {/* 2.1 action button option - export and export all */}
                                                    <div className="dropdown-menu" aria-labelledby='exportDropdownMenu'>
                                                        <span>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="export"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="yearlyPurchaseTitlesWithCostReport"
                                                                    filename="YearlyPurchaseTitlesWithCostReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export to Excel "
                                                                >
                                                                </ReactHTMLTableToExcel>
                                                            </div>
                                                            <div style={{ display: 'none' }}>
                                                                <ReactHTMLTableToExcel
                                                                    id="exportAll"
                                                                    className="btn outline-button waves-effect text-capitalize"
                                                                    table="ExportAllYearlyPurchaseTitlesWithCostReport"   // export all functionality
                                                                    filename="ExportAllYearlyPurchaseTitlesWithCostReport"
                                                                    sheet="tablexls"
                                                                    buttonText="Export All to Excel"
                                                                />
                                                            </div>
                                                            <button
                                                                onClick={this.formatCSVExportData}
                                                                className="dropdown-item"
                                                                title="Click to Export"
                                                                style={{ boxShadow: 'none' }}
                                                            >
                                                                Export
                                                            </button>
                                                            {this.state.isExportAllReportDataFetching ? (
                                                                <p className="dropdown-item">
                                                                    Exporting report . . .&nbsp;
                                                                    <FontAwesomeIcon
                                                                        icon={["fas", "circle-notch"]}
                                                                        className="rotate"
                                                                    />
                                                                </p>
                                                            ) : (
                                                                <button
                                                                    onClick={() => this.setState({ allReportData: {} }, () => {
                                                                        this.methodToExportReportData(0)
                                                                    })}
                                                                    className="dropdown-item"
                                                                    title="Click to Export All"
                                                                    style={{ boxShadow: 'none' }}
                                                                >
                                                                    Export All
                                                                </button>
                                                            )}
                                                        </span>

                                                    </div>

                                                </div>

                                                {/* 2 action button - print */}
                                                <div className="d-flex ml-2" title="Click to Print">
                                                    <span className="print-button">
                                                        <ReactToPrint
                                                            trigger={() => {
                                                                return (
                                                                    <div className="print-button btn outline-button ml-2" style={{ borderRadius: '5px', boxShadow: 'none !important' }}>
                                                                        <style type="text/css" media="print">
                                                                            {"@page { size: auto; }"}
                                                                        </style>
                                                                        <span>
                                                                            <FontAwesomeIcon icon={['fas', 'print']} size='lg' title="Click to Print" style={{ cursor: "pointer", color: '#0465AC' }} />
                                                                        </span>
                                                                    </div>
                                                                )
                                                            }}
                                                            content={() => this.componentRef}
                                                        />
                                                    </span>
                                                </div>

                                                {/* 3 action button - column visibility */}
                                                <div className="d-flex ml-2" title="Click to Customize Columns">
                                                    {/* <button className="print-button btn outline-button" style={{ borderRadius: '2.77px' }}> <style type="text/css" media="print">
                                        {"@page { size: auto; }"}
                                    </style> */}
                                                    <FontAwesomeIcon size='lg' id='settingsDropdownMenu' aria-expanded="false" data-toggle="dropdown" data-bs-toggle="dropdown" aria-haspopup="true" title="Click to Customize Columns" style={{ cursor: 'pointer', marginLeft: "8px", color: '#0465AC' }} color="#000" icon={['fas', 'cog']} />
                                                    {/* </button> */}

                                                    {/* action modal - column visibility*/}
                                                    <div className="dropdown-menu vm-dropdown-menu" aria-labelledby='settingsDropdownMenu'>
                                                        <div id='settingDropdown' className='settingDropdown-body'>
                                                            {
                                                                this.state.exportItemVisibilityForRows.map((columnInfo, index) => {
                                                                    return (
                                                                        <p className="dropdown-item" style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px' }} key={columnInfo.name} onClick={() => this.updateColumnDisplay(index)}>
                                                                            <span style={{ marginRight: 10 }}>{columnInfo.name}</span>
                                                                            <input type="checkbox" checked={columnInfo.isVisible} />
                                                                        </p>
                                                                    );
                                                                })
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                            </div>
                            {
                                (this.state.searchByAccessionNumber !== '' || this.state.searchByAccessionSeries.length !== 0 || this.state.searchByDepartment.length !== 0 || this.state.searchByResourceCategory.length !== 0 || this.state.searchByResourceType.length !== 0 || this.state.billFromDate !== "" || this.state.billToDate !== ""
                                ) &&
                                <div className='filter-apply'>
                                    <p className='vm_custom_body5'>Filters are applied.</p>
                                    <p className="clear-all vm_custom_body5" onClick={this.handleClearAllReportFilter}>Clear All</p>
                                </div>
                            }
                        </div>

                        {/* list table */}
                        <div className="col-md-12 px-0 div_table">
                            <div className="table-responsive fixTableHead table_pad" id='tableResponsive'>
                                <div className="print-area" ref={el => this.componentRef = el}>
                                    <div className="buildingReport_logo">
                                        <img className="report-college-logo" alt="college-logo" src={config.instructorInfo.InstituteLogo} />
                                        <p className="report-college-name">{ReactHtmlParser(config.instructorInfo.InstituteName)}</p>
                                        <h3>Yearly Purchase Titles With Cost</h3>
                                        {
                                            FilterArray.join(" | ")
                                        }
                                    </div>
                                    <table className="table table-bordered  vm_libraryReport_table" id="yearlyPurchaseTitlesWithCostReport">
                                        <thead>
                                            <tr>
                                                <tr className='d-none'>
                                                    <th colSpan="11" style={{ textAlign: 'center' }}>
                                                        {config.institute_name}
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="11" style={{ textAlign: 'center' }}>
                                                        Yearly Purchase Titles With Cost
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="11" ></th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="11" style={{ textAlign: 'center' }}>
                                                        {
                                                            FilterArray.join(" | ")
                                                        }
                                                    </th>
                                                </tr>
                                                <tr className='d-none'>
                                                    <th colSpan="30" ></th>
                                                </tr>
                                                <th>Sr.No</th>
                                                {this.state.exportItemVisibilityForRows[0].isVisible && <th>Date of Purchase</th>}
                                                {this.state.exportItemVisibilityForRows[1].isVisible && <th>Invoice/Bill Number</th>}
                                                {this.state.exportItemVisibilityForRows[2].isVisible && <th>Title</th>}
                                                {this.state.exportItemVisibilityForRows[3].isVisible && <th>Author</th>}
                                                {this.state.exportItemVisibilityForRows[4].isVisible && <th>Price Per Copy</th>}
                                                {this.state.exportItemVisibilityForRows[5].isVisible && <th>Net Price (in ₹ Per Copy)</th>}
                                                {this.state.exportItemVisibilityForRows[6].isVisible && <th>Discount (in %)</th>}
                                                {this.state.exportItemVisibilityForRows[7].isVisible && <th>Accession Series</th>}
                                                {this.state.exportItemVisibilityForRows[8].isVisible && <th>Accession Number</th>}
                                                {this.state.exportItemVisibilityForRows[9].isVisible && <th>Number Of Copies</th>}
                                                {this.state.exportItemVisibilityForRows[10].isVisible && <th>Call Number</th>}
                                                {this.state.exportItemVisibilityForRows[11].isVisible && <th>Resource Category</th>}
                                                {this.state.exportItemVisibilityForRows[12].isVisible && <th>Department</th>}
                                                {this.state.exportItemVisibilityForRows[13].isVisible && <th>Resource Type</th>}
                                            </tr>
                                        </thead>

                                        <tbody>
                                            {
                                                this.state.resourceListLoading ?
                                                    <tr>
                                                        <td colSpan="11">
                                                            <ButtonLoader />
                                                        </td>
                                                    </tr>
                                                    :
                                                    Object.keys(this.state.resourceList).length > 0 ?
                                                        (Object.values(this.state.resourceList).map((resource, index) => {
                                                            return (

                                                                <tr key={index}>
                                                                    <td>{
                                                                        this.state.limit === 'all' ? index + 1 :
                                                                            ((this.state.pageIndex - 1) * this.state.limit) + index + 1
                                                                    }</td>
                                                                    {this.state.exportItemVisibilityForRows[0].isVisible && <td>{resource?.dateOfPurchace || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[1].isVisible && <td>{resource?.billno || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[2].isVisible && <td>{resource?.title || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[3].isVisible && <td>{resource?.author || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[4].isVisible && <td>{resource?.price || "-"}</td>}
                                                                    {this.state.exportItemVisibilityForRows[5].isVisible && <td>{resource?.netprice || "-"}</td>}
                                                                    {this.state.exportItemVisibilityForRows[6].isVisible && <td>{resource?.discount || "-"}</td>}
                                                                    {this.state.exportItemVisibilityForRows[7].isVisible && <td>{resource?.AccessionText || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[8].isVisible && <td>{resource?.accessionnumber || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[9].isVisible && <td>{resource?.noOfCopies || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[10].isVisible && <td>{resource?.callNumber || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[11].isVisible && <td>{resource?.resourceCategoryName || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[12].isVisible && <td>{resource?.stream_name || ""}</td>}
                                                                    {this.state.exportItemVisibilityForRows[13].isVisible && <td>{resource?.resource_type || ""}</td>}
                                                                </tr>
                                                            )
                                                        })) : <tr>
                                                            <td colSpan="11">
                                                                No details found.
                                                            </td>
                                                        </tr>
                                            }

                                            {
                                                // display total and grand total count
                                                Object.keys(this.state.resourceList).length > 0 ?
                                                    this.state.resourceListLoading ? null :
                                                        <>
                                                            <tr>
                                                                <td colSpan="1" style={{ textAlign: "right", fontWeight: "bold" }}>Total</td>
                                                                <td colSpan="4"></td>
                                                                {/* Sum of price */}
                                                                {this.state.exportItemVisibilityForRows[4].isVisible && <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                                                    {this.state.priceTotalCount}
                                                                </td>}
                                                                <td colSpan="11"></td>
                                                            </tr>
                                                            <tr>
                                                                <td colSpan="1" style={{ textAlign: "right", fontWeight: "bold" }}>Grand Total</td>
                                                                <td colSpan="4"></td>
                                                                {/* Grand total of price */}
                                                                {this.state.exportItemVisibilityForRows[4].isVisible && <td style={{ textAlign: "right", fontWeight: "bold" }}>
                                                                    {this.state.priceTotal}
                                                                </td>}
                                                                <td colSpan="11"></td>
                                                            </tr>
                                                        </>
                                                    : null
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            {/* table footer pagination */}
                            {
                                (Object.keys(this.state.resourceList).length > 0 || Object.keys(this.state.resourceList).length > this.state.limit) &&
                                <div className='row px-0'>
                                    <div className='col-md-12 px-0' style={{ background: "#f5f8fa", borderRadius: "4px" }}>
                                        <div className='row align-items-center justify-content-between'>
                                            <div className='col-lg-4 col-md-12 col-12 pl-0 hidePrint'>
                                                <div className='d-flex justify-content-lg-start justify-content-sm-center justify-content-center '>
                                                    <span className="d-flex align-items-center" style={{ fontSize: 14, marginLeft: 4 }}>
                                                        <select className="mx-2 p-1 vm_select_border" name="pageSize" id=""
                                                            value={this.state.limit}
                                                            onChange={this.changeShowEntriesControl}
                                                        >
                                                            <option value={10}>Entries Per Page 10</option>
                                                            <option value={25}>Entries Per Page 25</option>
                                                            <option value={40}>Entries Per Page 40</option>
                                                            <option value={100}>Entries Per Page 100</option>
                                                            <option value={250}>Entries Per Page 250</option>
                                                        </select>
                                                    </span>
                                                </div>
                                            </div>
                                            <div className='col-lg-4 col-md-12 col-12 justify-content-center'>
                                                <div id="paginationContainer" className="hidePrint" style={{ margin: "12px auto" }}>
                                                    <Pagination
                                                        activePage={this.state.pageIndex}
                                                        itemsCountPerPage={this.state.limit}
                                                        totalItemsCount={this.state.totalResourceListItems}
                                                        pageRangeDisplayed={3}
                                                        onChange={this.updatePaginationCount}
                                                    />
                                                </div>
                                            </div>
                                            {
                                                this.returnExportAllData()
                                            }
                                            <div className='col-lg-4 col-md-12 col-12 pr-0 hidePrint'>
                                                <span className="d-flex justify-content-end align-items-center " style={{ fontSize: 14, marginRight: "21px" }}>
                                                    Total Records : {this.state.totalResourceListItems || 0}
                                                </span>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>

                        {
                            this.returnAdvanceFilterModelData()
                        }
                    </div >
                </div>
            </div >

        );
    }
}


export default YearlyPurchaseTitleWithCostReport;